module.exports = __webpack_public_path__ + "img/ar.6e36026.svg";